// extracted by mini-css-extract-plugin
module.exports = {"packingInstruction":"_2HO4R","packingInstruction-content":"gza44"};